jQuery.fn.within = function (pSelector) {
	return this.filter(function () {
		return jQuery(this).closest(pSelector).length;
	});
};

document.addEventListener('DOMContentLoaded', function () {
	//GUTENBERG GALLERIES CANNOT BE HOOKED
	var existingGalleries = document.getElementsByClassName('wp-block-gallery');
	for (var i = 0, len = existingGalleries.length; i < len; i++) {
		var currentGallery = existingGalleries[i];
		var images = currentGallery.querySelectorAll('[class="blocks-gallery-item"]');
		var newGalleryHTML = '<div class="splide sportdata-post-gallery">'
			+ '<div class="splide__track">'
			+ '<ul class="splide__list">';
		for (var j = 0, len2 = images.length; j < len2; j++) {
			var currentImage = images[j];
			currentImage.classList.add('text-center');
			newGalleryHTML += '<div class="splide__slide">';
			newGalleryHTML += currentImage.outerHTML.replace("wp-image-", "img-fluid wp-image-");
			newGalleryHTML += '</div>';
		}
		newGalleryHTML += '</ul></div></div>';
		var newGallery = document.createElement('div');
		newGallery.classList.add('splide');
		newGallery.classList.add('sportdata-post-gallery');
		newGallery.innerHTML = newGalleryHTML;
		currentGallery.parentNode.insertBefore(newGallery, currentGallery);
		currentGallery.classList.add('sportdata-remove');
	}
	document.querySelectorAll('.sportdata-remove').forEach(e => e.remove());
	var elms = document.getElementsByClassName('splide');
	for (var i = 0, len = elms.length; i < len; i++) {
		var splideOptions = {
			type: 'loop',
			perPage: 1,
			perMove: 1,
			autoplay: true,
			gap: '1rem',
			lazyLoad: 'nearby',
			pagination: false,
			//cover: true //not working for sportdataclub.com home
		};
		var currentSplide = new Splide(elms[i], splideOptions).mount();
	}
});

//MAKE STICKY ELEMENTS HIGHLIGHT
var observer = new IntersectionObserver(stickyObserverCallback, { threshold: [1] });
function stickyObserverCallback(entries, observer) {
	entries.forEach(entry => {
		entry.target.classList.toggle("is-pinned", !entry.isIntersecting && (entry.intersectionRatio > 0.9 || entry.intersectionRatio < 0.1));
	});
};
document.querySelectorAll(".sportdata-sticky-left").forEach((i) => {
	if (i) {
		observer.observe(i);
	}
});


(function ($) {
	$('[data-toggle="tooltip"]').tooltip();
	$(window).ready(function () {
		if ($("article.sportdata-article.single").length === 1) {
			$("article.sportdata-article.single .entry-content .teads-in-read-1, article.sportdata-article.single .entry-content .teads-in-read-2").each(function () {
				if ($(this).html().length > 0) {
					$(this).css("padding", "3rem 0");
				}
			});
		}
		if ($('.sportdata-horse').length > 0) {
			$('.sportdata-horse .sportdata-stats').each(function () {
				var currentSection = $(this);
				var allRowsCount = 0;
				var tables = currentSection.find('table').each(function () {
					var thisTableRowsCount = $(this).find('tbody tr:not(.totals)').length;
					allRowsCount += thisTableRowsCount;
					if (thisTableRowsCount == 0) {
						$(this).addClass('d-none');
					}
				});
				if (allRowsCount == 0) {
					currentSection.addClass('d-none');
				}
			});
		}
		$('.sportdata-autocomplete-field.cavalli').each(function () {
			var spinner_id = $(this).data('spinner');
			$(this).autocomplete({
				source: function (request, response) {
					$.getJSON(window.sportdata_BASE_URL + "/wp-json/sportdata/v1/horses-list?search_by_name=" + request.term, function (data) {
						response($.map(data, function (horse, key) {
							if (horse) {
								return {
									label: horse.name,
									value: horse.name
								};
							} else {
								return false;
							}
						}));
					});
				},
				search: function (event, ui) {
					$('#' + spinner_id).first().show();
				},
				response: function (event, ui) {
					$('#' + spinner_id).first().hide('fade', 300);
				},
				minLength: 4,
				delay: 131,
				appendTo: $(this).parent(),
			});
		});
		$('.sportdata-race-single .sportdata-race-presences table tbody tr, .sportdata-race-single .sportdata-race-betting table tbody tr').each(function () {
			var currentRow = $(this);
			var highestBet = 0;
			(['winner', 'placed']).forEach(function (betType) {
				highestBet = 0;
				currentRow.find('.odds .' + betType).each(function () {
					var currentCell = $(this);
					var currentBet = parseFloat(currentCell.find('a').html().replace(',', '.'));
					if (currentBet > 0) {
						switch (true) {
							case (currentBet > highestBet):
								highestBet = currentBet;
								currentRow.find('.odds .' + betType + '.best').removeClass('best');
								currentCell.addClass('best');
								break;
							case (currentBet == highestBet):
								currentCell.addClass('best');
								break;
							default:
						}
					}
				});
			});
		});
		$('[data-toggle="popover"]').popover({
			html: true,
			trigger: 'focus',
			content: function () {
				var content = $(this).attr("data-popover-content");
				return $(content).html();
			},
		});
	});
	$('.sportdata-back-button button').on('click', function () {
		window.history.back();
	});

	//REDIRECT AFTER BUYING SINGLE COPY
	$("a[data-sportdata-redirect-to]").on("click", function () {
		let redirectURL = $(this).data("sportdata-redirect-to");
		try {
			let url = new URL(redirectURL);
			if (url.origin === "https://sportdata.memberful.com") {
				sessionStorage.setItem("sportdata-redirect-to-magazine", url.searchParams.get("mt_magazineId"));
			}
		} catch (e) {

		}
	});

	var sportdataSortTable = function (sortButton) {
		var table, x, y, columnIndex, isActive, sortDirection, isPerizia;
		isActive = sortButton.hasClass('active');
		isPerizia = sortButton.closest('th').hasClass('perizia');
		previousSort = "zzzz";
		if (isActive) {
			previousSort = sortButton.data('current');
			switch (sortButton.data('current')) {
				case 'up':
					sortDirection = 'down';
					break;
				case 'down':
					sortDirection = 'up';
					break;
				default:
					sortDirection = sortButton.data('default');
			}
		} else {
			sortDirection = sortButton.data('default');
		}
		if (sortDirection === 'up') {
			directionValues = [1, -1];
		} else {
			directionValues = [-1, 1];
		}
		table = sortButton.closest('table');
		columnIndex = sortButton.closest('th').index();
		tbody = table.find('tbody');
		tbody.find('tr').sort(function (a, b) {
			x = $(a).find("td:eq(" + columnIndex + ")").text().replace(',', '.');
			y = $(b).find("td:eq(" + columnIndex + ")").text().replace(',', '.');
			if (!isNaN(x)) {
				x = parseFloat(x);
			} else {
				x = x.toLowerCase();
			}
			if (!isNaN(y)) {
				y = parseFloat(y);
			} else {
				y = y.toLowerCase();
			}
			if (isPerizia) {
				switch (true) {
					case (x > y): case (isNaN(y) && !isNaN(x)):
						return directionValues[0];
						break;
					case (x < y): case (isNaN(x) && !isNaN(y)):
						return directionValues[1];
						break;
					default:
						return 0;
				}
			} else {
				switch (true) {
					case (x > y): case (isNaN(x) && !isNaN(y)):
						return directionValues[0];
						break;
					case (x < y): case (isNaN(y) && !isNaN(x)):
						return directionValues[1];
						break;
					default:
						return 0;
				}
			}
		}).appendTo(tbody);
		if (!isActive) {
			oldActive = table.find(".sportdata-sort.active");
			oldActive.removeClass("active");
			oldActive.data('current', null);
			oldActive.find('.fa-sort-up, .fa-sort-down').addClass('d-none');
			oldActive.find('.fa-sort').removeClass('d-none');
			sortButton.addClass("active");
		}
		sortButton.data('current', sortDirection);
		sortButton.find('.fa-sort, .fa-sort-' + previousSort).addClass('d-none');
		sortButton.find('.fa-sort-' + sortDirection).removeClass('d-none');
		sortButton.closest('th').tooltip('hide');
	}

	$("table.sportdata-sortable .sportdata-sort").on("click", function () {
		sportdataSortTable($(this));
	});

	$('.sportdata-requires-legal-consent').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		var hiddenLinkID = $(this).data('hidden-link-id');
		var planURL = $('#' + hiddenLinkID).attr('href');
		$('#legalConsentModal').find('.modal-footer .sportdata-accept').attr('href', planURL);
		$('#legalConsentModal').modal('show');
	});

	$('#legalConsentModal').on('show.bs.modal', function (event) {
		var consentModal = $(this);
		consentModal.find('input[type=checkbox]').removeAttr('checked');
		consentModal.find('input[type=radio]').removeAttr('checked');
		consentModal.find('.modal-footer .sportdata-accept').addClass('disabled');
	})

	$('#legalConsentModal input[type=checkbox], #legalConsentModal input[type=radio]').on('change', function () {
		var consentCount = $('#legalConsentModal input[type=checkbox]:checked').length + $('#legalConsentModal input[type=radio]:checked').length;
		var consentModal = $(this).closest('.modal');
		var submitButton = consentModal.find('.modal-footer .sportdata-accept');
		var userAcceptsMarketing = $('#legalConsentModal #marketingConsentOK').is(':checked');
		var userAcceptsPartners = $('#legalConsentModal #partnersConsentOK').is(':checked');
		var planURL = submitButton.attr('href');

		if (userAcceptsMarketing) {
			planURL = planURL.replace("mt_userAcceptsMarketing=false", "mt_userAcceptsMarketing=true");
		} else {
			planURL = planURL.replace("mt_userAcceptsMarketing=true", "mt_userAcceptsMarketing=false");
		}
		if (userAcceptsPartners) {
			planURL = planURL.replace("mt_userAcceptsPartners=false", "mt_userAcceptsPartners=true");
		} else {
			planURL = planURL.replace("mt_userAcceptsPartners=true", "mt_userAcceptsPartners=false");
		}
		submitButton.attr('href', planURL);
		if (userAcceptsMarketing || userAcceptsPartners) {
			var memberfulObjectReset = new Memberful.UserTracker().setup();
		}

		if (consentCount === $('#legalConsentModal input[type=checkbox]').length + ($('#legalConsentModal input[type=radio]').length / 2)) {
			submitButton.removeClass('disabled');
		} else {
			submitButton.addClass('disabled');
		}
	});

	//SECONDARY NAVIGATION ON SCROLL
	var secNavigationTimer = null;
	var previousYPosition = 0;
	var sportdataTriggerSecondaryNavigation = function () {
		if (secNavigationTimer !== null) {
			clearTimeout(secNavigationTimer);
		}
		secNavigationTimer = setTimeout(function () {
			if (document.documentElement.scrollTop > previousYPosition) {
				$('.site-header .sportdata-secondary-navigation').addClass('folded-up');
			} else {
				$('.site-header .sportdata-secondary-navigation').removeClass('folded-up');
			}
			previousYPosition = document.documentElement.scrollTop;
		}, 300);
	};
	$(window).scroll(function () {
		sportdataTriggerSecondaryNavigation();
	});
	sportdataTriggerSecondaryNavigation();
	$(window).ready(function () {
		if ($(".sportdata-check-if-mobile:visible").length > 0) {
			$('.site-header .sportdata-secondary-navigation').addClass('folded-up');
		}
	});
})(jQuery);